import { multiZoneRecommendation } from '../data/processor/multiZone';
import { needCategoryFallbackRecommendations, needFccRecommendation } from '../utils/utils';
import getFccRecommendations from './fcc';
import getProsRecommendations from './pros';
import getCategoryFallbackRecommendations from './category';

const getRecommendations = async ({ config, properties }) => {
  const entryPoint = process.env.ENTRY_POINT;
  let setupRequest;
  try {
    const module = await import(`./${entryPoint}/recommendationRequestData`);
    setupRequest = module.default;
  } catch (err) {
    throw new Error(`Module load failed ${err.message}}`);
  }

  const request = setupRequest(config, properties);

  try {
    const response = await getProsRecommendations(request);
    const { data } = response;

    properties.enableColorRecommendations = data?.uiKillSwitches?.enableColorRecommendations || false;

    if (data && data.recommendedItems && !data.recommendedItems.length) {
      // TODO: hide loader
    }

    if (needCategoryFallbackRecommendations(data)) {
      return getCategoryFallbackRecommendations(request, config, properties, data);
    }

    if (needFccRecommendation({ config, properties, response: data })) {
      return getFccRecommendations(request, properties, data);
    }

    // TODO: store data in store, use for multizone
    return multiZoneRecommendation(request, data);
  } catch (e) {
    if (needFccRecommendation({ request, properties })) {
      return getFccRecommendations(request, properties);
    }

    // TODO: update error message
    throw new Error(`Recommendations call failed: ${e}`);
  }
};

export default getRecommendations;
